import { render, staticRenderFns } from "./bindPersonCurd.vue?vue&type=template&id=4714f4d7&scoped=true&"
import script from "./bindPersonCurd.vue?vue&type=script&lang=js&"
export * from "./bindPersonCurd.vue?vue&type=script&lang=js&"
import style0 from "./bindPersonCurd.vue?vue&type=style&index=0&id=4714f4d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4714f4d7",
  null
  
)

export default component.exports